import { Header } from './header/Header';
import { Footer } from './footer/Footer';
import Box from '@mui/material/Box';
import { useTournamentCheckIn } from 'src/hooks/useTournamentCheckIn';
// import { useParallax } from 'react-scroll-parallax';

export type MainLayoutProps = {
  children: React.ReactNode;
};

export function MainLayout({ children }: MainLayoutProps) {
  // const { ref } = useParallax({
  //   speed: -20,
  // });

  useTournamentCheckIn();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        marginBottom: '-24px',
      }}
    >
      <Header />
      <Box sx={{ mt: 15 }}>
        <main>{children}</main>
      </Box>

      {/* <Box
        sx={{
          position: 'absolute',
          top: '190px',
          left: '0',
          width: '100%',
          height: 'calc(100% - 360px)',
          background:
            'linear-gradient(180deg, rgba(0,14,33,0.1) 0%, rgba(0,14,33,0.1) 4%, rgba(0,0,0,0) 5%, rgba(0,0,0,0) 95%, rgba(0,21,52,0.1) 90%, rgba(0,21,52,1) 100%), url("/assets/images/background-shapes.png")',
          backgroundRepeat: 'repeat-y',
          zIndex: -1,
        }}
        ref={ref}
      /> */}
      <Footer />
    </Box>
  );
}
